import React from 'react';
import { Box, Container,Button, Typography, Grid, Card, CardContent, useTheme } from '@mui/material';
import { Assignment, Visibility, Groups } from '@mui/icons-material';
import Navbar from './layout/Navbar';
import Footer from './layout/Footer';

const AboutUsPage = () => {
  const theme = useTheme();

  return (
    <>
    <Navbar/>
    <Box sx={{ backgroundColor: theme.palette.background.default }}>
      {/* Hero Section */}
      <Box sx={{
  position: 'relative',
  minHeight: '400px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  overflow: 'hidden',
  background: `
    linear-gradient(15deg, rgba(18, 18, 18, 0.7) 30%, rgba(255, 255, 255, 0.1) 100%),
    url(/path-to-image.jpg) center/cover
  `,
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: `linear-gradient(45deg, ${'#1E7CB7'}33 0%, ${'#2FA8EF'}22 100%)`,
  }
}}>
  <Container maxWidth="lg" sx={{
    position: 'relative',
    zIndex: 2,
    color: 'common.white',
    px: { xs: 2, md: 4 },
    py: 6
  }}>
    <Typography variant="h1" sx={{
      fontWeight: 400,
      letterSpacing: '0.03em',
      lineHeight: 1.2,
      mb: 3,
      fontSize: { xs: '2.5rem', md: '4rem' },
      textShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
      '&:after': {
        content: '""',
        display: 'block',
        width: '80px',
        height: '2px',
        backgroundColor: '#2FA8EF',
        mx: 'auto',
        mt: 3
      }
    }}>
      About Elite Magnessa
    </Typography>

    <Typography variant="subtitle1" sx={{
      maxWidth: '680px',
      mx: 'auto',
      fontSize: { xs: '1.1rem', md: '1.25rem' },
      fontWeight: 300,
      letterSpacing: '0.03em',
      lineHeight: 1.6,
      color: 'rgba(255, 255, 255, 0.9)',
      fontStyle: 'italic',
      mb: 4
    }}>
      Empowering Natural Lifestyles & Entrepreneurial Spirit
    </Typography>

    {/* <Button 
      variant="outlined" 
      sx={{
        color: 'common.white',
        borderColor: '#2FA8EF',
        '&:hover': {
          backgroundColor: '#2FA8EF22',
          borderColor: '#2FA8EF'
        }
      }}
    >
      Explore Our Vision
    </Button> */}
  </Container>
</Box>

      {/* Who We Are Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom sx={{ color: '#1E7CB7', fontWeight: 600 }}>
              Who We Are
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: '#555', lineHeight: 1.8 }}>
              Elite Magnessa formed with an aim of moving forward with that business vision, mission and ideas which helps in the enrichment of health, wealth and prosperity of the consumers. Our company provides high-quality food supplements and herbal products that offer exceptional value for consumer health.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box sx={{
              height: 300,
              backgroundColor: '#2FA8EF33',
              borderRadius: 4,
              backgroundImage: 'url(/placeholder-about.jpg)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }} />
          </Grid>
        </Grid>
      </Container>

      {/* Mission & Vision Section */}
      <Box sx={{ backgroundColor: '#f9f9f9', py: 8 }}>
        <Container maxWidth="lg">
          <Grid container spacing={6}>
            <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%',
                borderTop: '4px solid #2FA8EF'
              }}>
                <CardContent>
                  <Assignment sx={{ fontSize: 40, color: '#1E7CB7', mb: 2 }} />
                  <Typography variant="h5" gutterBottom sx={{ color: '#1E7CB7', fontWeight: 600 }}>
                    Our Mission
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#555' }}>
                    To create a vicious cycle of empowerment by training and supporting social entrepreneurs through our direct selling model, enhancing both physical and financial immunity for our community.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ 
                height: '100%',
                borderTop: '4px solid #2FA8EF'
              }}>
                <CardContent>
                  <Visibility sx={{ fontSize: 40, color: '#1E7CB7', mb: 2 }} />
                  <Typography variant="h5" gutterBottom sx={{ color: '#1E7CB7', fontWeight: 600 }}>
                    Our Vision
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#555' }}>
                    To establish a sustainable business model that enables vertical social mobility, particularly empowering youth and women through Nepali-made products designed for global impact.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Values Section */}
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Typography variant="h4" align="center" gutterBottom sx={{ 
          color: '#1E7CB7',
          fontWeight: 600,
          mb: 6
        }}>
          Our Approach
        </Typography>
        <Grid container spacing={4}>
          {[
            { 
              title: 'Eco-Conscious Business', 
              text: 'Implementing sustainable practices to preserve nature and support ecosystem health' },
            { icon: <Groups sx={{ fontSize: 40 }} />, 
              title: 'Entrepreneur Empowerment', 
              text: 'Creating financial comfort zones through modern business action plans' },
          ].map((item, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Box sx={{ 
                display: 'flex',
                alignItems: 'center',
                p: 3,
                backgroundColor: index % 2 === 0 ? '#1E7CB711' : '#2FA8EF11',
                borderRadius: 3
              }}>
                <Box sx={{ 
                  color: index % 2 === 0 ? '#1E7CB7' : '#2FA8EF',
                  mr: 3
                }}>
                  {item.icon}
                </Box>
                <Box>
                  <Typography variant="h6" sx={{ 
                    color: '#1E7CB7',
                    fontWeight: 600,
                    mb: 1
                  }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body1" sx={{ color: '#555' }}>
                    {item.text}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
    <Footer/>
    </>
  );
};

export default AboutUsPage;